import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AmountUtils, DateUtils } from '@shared/utils';
import type { CardAccountBalanceReportResponse } from '@shared/api';
import { Table, TableCellType } from '@shared/widgets';

interface AccountTableProps {
  isLoading?: boolean;
  error?: string | null;
  onRefresh?: () => void;
  accounts: CardAccountBalanceReportResponse[];
  currentPage: number;
  totalItemCount: number;
  countItemPage: number;
  onChangePage: (pageNumber: number) => void;
  onChangeCountItemPage: (pageNumber: number) => void;
}
export const AccountTable = (props: AccountTableProps) => {
  const { t } = useTranslation('reports');

  const columns = useMemo(
    () => [
      t('card.account.columns.date'),
      t('card.account.columns.accountLabel'),
      t('card.account.columns.currency'),
      t('card.account.columns.availableBalance'),
    ],
    [t],
  );
  return (
    <Table
      isScrollable
      isLoading={props.isLoading}
      error={props.error}
      onRefresh={props.onRefresh}
      columns={columns}
      items={props.accounts.map((row) => [
        { type: TableCellType.Text, value: DateUtils.formatDate(row.dateCreated) },
        { type: TableCellType.Text, value: row.accountLabel ? row.accountLabel : row.accountName.replaceAll('X', '*') },
        { type: TableCellType.Text, value: row.currency.toUpperCase() },
        { type: TableCellType.Text, value: AmountUtils.transformToAmountWithCurrency(row.availableBalance, row.currency) },
      ])}
      pagination={{
        currentPage: props.currentPage,
        totalItemCount: props.totalItemCount,
        countItemPage: props.countItemPage,
        onChangePage: props.onChangePage,
        onChangeCountItemPage: props.onChangeCountItemPage,
      }}
    />
  );
};
